import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { corekaPageMeta, corekaSchema } from 'components/common/schema'
import Template from 'components/cases/coreka'

const Coreka: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...corekaPageMeta} />
      <JsonLd data={corekaSchema} />
      <Template />
    </>
  )
}

export default Coreka
